import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    addRecord,
    addRecordSuccess,
    addRecordFailure,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure
} from './club-notes.action';
import { ClubNote } from './club-notes.model';

export interface ClubNoteRecordsState {
    listData: any[];
    singleData: ClubNote;
    loading: boolean;
    updating: boolean;
    error: any;
    total: number;
}

export const initialState: ClubNoteRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    updating: false,
    error: null,
    total: 0,
};


export const clubNoteRecordReducer = createReducer(
    initialState,

    // Fetch Rcords
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Fetch Single Record
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    // Add Records
    on(addRecord, (state) => {
        return { ...state, updating: true, error: null };
    }),
    on(addRecordSuccess, (state) => {
        return { ...state, updating: false };
    }),
    on(addRecordFailure, (state, { error }) => {
        return { ...state, error };
    }),

    // Update Records
    on(updateRecord, (state) => {
        return { ...state, updating: true, error: null };
    }),
    on(updateRecordSuccess, (state) => {
        return { ...state, updating: false };
    }),
    on(updateRecordFailure, (state, { error }) => {
        return { ...state, error };
    }),

    //Reset State
    on(resetState, () => initialState)  // Reset action handler
);